<template>
  <div>
    <div v-if="isPack">
      <open-screen v-bind:fromIndexRes="fromIndexResouresData"></open-screen>
      <open-class-list @isOpenDetail="showPlayer" v-bind:fromIndexRes="fromIndexResouresData"></open-class-list>
    </div>
    <open-detail v-if="isOpenDetail" @isBack="isBack" v-bind:lessonTest="lessonTest"></open-detail>
  </div>

</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import OpenScreen from '../PackageScreen/OpenScreen.vue'
  import OpenClassList from '../OpenClassList/OpenClassList.vue'
  import OpenDetail from '../OpenDetail/OpenDetail.vue'
  export default {
    name: 'OpenClass',
    props:{
      IndexOpenData:{
        type:Object,
        default:{
          isOpenDetail:false
        }
      },
      fromIndexResouresData:{
        type:Object,
        default:{'isFromIndexSyn':null,'subjectId':null,'routerMicroName':null}
      }
    },
    data() {
      return {
        msgId: null,
        isPack:true,
        isOpenDetail:false,
        lessonTest:{isOpen:false}
      }
    },
    watch:{
      IndexOpenData:function(newVal,oldVal){
        console.log(newVal,'最新值')
      },
      fromIndexOpenTabData:function(newVal,oldVal){
        console.log(newVal,'最新值')
      }
    },
    mounted() {
      let that = this;
      if(this.IndexOpenData.isOpenDetail){
        this.isPack = false;
        this.isOpenDetail = true;
        this.IndexOpenData.isOpenDetail = false;
        this.lessonTest = {'lessonId':this.IndexOpenData.lessonId,'isOpen':true};
      }
	  this.$nextTick(()=>{
	    $(document).scrollTop(0);
	  })
    },
    methods:{
        showPlayer(obj){
            this.isOpenDetail = obj;
            this.isPack = false;
        },
        isBack(obj){
          this.isOpenDetail = false;
          this.isPack = true;
        }
    },
    components: {
      OpenScreen,OpenClassList,OpenDetail
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/OpenClass/OpenClass.vue